export default {
  // 標題
  output: "輸出",

  // 按鈕
  collapseAll: "收起全部",
  viewAll: "查看全部",

  // 消息提示
  copySuccess: "複製成功",
};
